import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const BottomActionsContainer = styled.div({
  display: "flex",
  justifyContent: "flex-end",
});
